module.exports = __webpack_public_path__ + "img/5.7d5ccb11.png";